module.exports = __webpack_public_path__ + "img/select.7c72f9e2.svg";